import React, { FC } from 'react'
import { ListItem, Text, VStack } from '@chakra-ui/react'

interface DescriptionItemProps {
  title: string
  content?: string
}

const DescriptionItem: FC<DescriptionItemProps> = ({ title, content }) => {
  if (!content || content === '-') {
    return null
  }

  return (
    <ListItem>
      <VStack align="flex-start">
        {title ? (
          <Text fontSize="sm" fontWeight="bold">
            {title}
          </Text>
        ) : null}
        <Text fontSize="lg">{content}</Text>
      </VStack>
    </ListItem>
  )
}

export default DescriptionItem
